<template>
  <button class="btn"
  :class="{ 'btn-primary': isOn, 'btn-secondary': !isOn}"
  @click="$emit('click')"
  v-html="isOn ? '<strong>On</strong>' : 'Off'"></button>
</template>
<script>
  export default {
    props: {
      isOn: Boolean,
    },
  }
</script>
